import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalComponent } from '@/components/molecules/ModalComponent';

import styles from './styles.module.scss';

interface FabProps {
    onClick: () => void;
}

function Fab({ onClick }: FabProps) {
    const { t } = useTranslation();

    return (
        <nav className={styles['fab-container']}>
            <button
                type="button"
                className={styles['fab-item']}
                title={t('molecules.howMuchIsTheFish.howMuchIsTheFish')}
                onClick={onClick}>
                <span role="img" aria-label={t('molecules.howMuchIsTheFish.fish')}>
                    🐟
                </span>
            </button>
        </nav>
    );
}

function HowMuchIsTheFish() {
    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(false);
    // The modal's own dismissal closes it: a click on the backdrop or Escape. Clicks in the
    // video stay in its frame and never reach the page.
    return (
        <div>
            <Fab onClick={() => setOpen(true)} />
            <ModalComponent
                isOpen={isOpen}
                onClose={() => setOpen(false)}
                aria-label={t('molecules.howMuchIsTheFish.howMuchIsTheFish')}
                centered={false}
                body={
                    <div className={styles['video-wrapper']}>
                        <iframe
                            title="howmuchisthefish"
                            className={styles['responsive-iframe']}
                            id="ytplayer"
                            src="https://www.youtube.com/embed/cbB3iGRHtqA?autoplay=1&fs=1&mute=1"
                        />
                    </div>
                }
            />
        </div>
    );
}

export default HowMuchIsTheFish;
export { HowMuchIsTheFish };
